<div class="row page-header-container {{ isTabHeader }}">
  <div
    class="d-flex justify-content-start align-items-center"
    [ngClass]="{
      'col-md-9': actionButtons?.length > 0,
      'col-md-12': actionButtons?.length <= 0
    }"
  >
    <button
      size="small"
      nbButton
      status="primary"
      appearance="ghost"
      class="mr-3"
      *ngIf="onBack"
      (click)="onBackClick()"
    >
      <nb-icon icon="arrow-left" pack="fci" style="font-size: 1rem"></nb-icon>
    </button>
    <app-media-info-card
      *ngIf="heading"
      [renderValue]="{
        iconUrl: !primaryIcon?.img && primaryIcon?.icon ? primaryIcon.icon : null,
        imgUrl: primaryIcon?.img || null,
        textIcon: this.titleIconName,
        wideIconDimensions: true,
        iconPack: primaryIcon?.pack || 'fci',
        headerIcon: !!primaryIcon?.headerIcon,
        iconSize: 2.25,
        title: heading,
        titleFontSize: 22,
        showTitle: true,
        subHeading: subheading,
        toolTipText: headingIconTooltip,
        isNbIcon: showPrimaryIcon,
        openNewTab: pageHeadingTextAsLink?.openInNewTab,
        url: pageHeadingTextAsLink?.link,
        linkToolTip: pageHeadingTextAsLink?.tooltip,
      }"
      class="d-flex align-items-center"
    >
      <ng-content select="[subtitle]"></ng-content>
    </app-media-info-card>
    <ng-content selector="[headerSuffixComponent]"></ng-content>
    <h1 [ngClass]="headingIconClass">
      <nb-icon
        *ngFor="let icon of headingIcons"
        [icon]="icon?.icon"
        [pack]="icon?.pack || 'fci'"
        [status]="icon?.status"
        [ngClass]="
          'ml-2 ' +
          (icon?.class || '') +
          'd-flex justify-content-center align-items-center'
        "
        [ngStyle]="{ 'font-size': icon.iconSize }"
        [nbTooltip]="icon?.iconTooltip"
        [nbTooltipDisabled]="!icon?.iconTooltip"
      ></nb-icon>
    </h1>
  </div>
  <app-page-action-buttons
    class="col-md-3 d-flex justify-content-end align-items-center"
    *ngIf="actionButtons?.length !== 0"
    [actionButtons]="actionButtons"
    [analyticsData]="analyticsData"
    [analyticsPrefix]="analyticsPrefix"
    [showHighlighterForMoreActions]="showHighlighterForMoreActions"
    [buttonClass]="buttonClass"
    (buttonClickEvent)="onButtonClick($event)"
  ></app-page-action-buttons>
</div>
